<script lang="ts">
  import { onMount } from 'svelte';
  import { login, logout } from '../lib/auth.svelte';
  import {
    planFromDemoSlug,
    demoTenantForPlan,
    demoAdminUser,
    type HospitalDemoPlan,
  } from '../lib/hospital-preview.svelte';
  import { DEMO_SEED_KEY } from '../lib/demo-seed-shared';
  import { clearTenantContext } from '../lib/tenant.svelte';const REGISTRO = 'https://app.toscana-hospital.com/registro?plan=hospital-pro';

  let slug = $state<HospitalDemoPlan>('pro');
  let loading = $state(false);
  let error = $state<string | null>(null);

  const LABELS: Record<HospitalDemoPlan, { emoji: string; title: string }> = {
    starter: { emoji: '🏥', title: 'Hospital Starter' },
    pro: { emoji: '🏨', title: 'Hospital Pro' },
    enterprise: { emoji: '🌐', title: 'Hospital Enterprise' },
  };

  onMount(() => {
    const m = location.pathname.match(/\/demo\/(starter|pro|enterprise)/);
    slug = planFromDemoSlug(m?.[1]) ?? 'pro';
    void entrarDemo();
  });

  async function entrarDemo() {
    loading = true;
    error = null;
    try {
      const tenantId = demoTenantForPlan(slug);
      const usuario = demoAdminUser(tenantId);
      sessionStorage.removeItem('toscana.clinicPreview');
      sessionStorage.setItem('toscana.demo.tenant', tenantId);
      clearTenantContext();
      logout();
      await login(tenantId, usuario, 'Demo-Toscana-2026');
      sessionStorage.setItem(DEMO_SEED_KEY, slug);
      location.replace('/');
    } catch (e: any) {
      error = e?.message ?? String(e);
    } finally {
      loading = false;
    }
  }

  const meta = $derived(LABELS[slug] ?? LABELS.pro);
</script>

<div class="wrap">
  <div class="card">
    <span class="emoji">{meta.emoji}</span>
    <h1>Demo · {meta.title}</h1>
    <p>Entrando con datos de hospital (camas, quirófano, MSPAS…)…</p>
    {#if loading}<p class="muted">Conectando demo…</p>{/if}
    {#if error}
      <p class="err">{error}</p>
      <button type="button" onclick={entrarDemo}>Reintentar</button>
      <p class="muted">También puede <a href={REGISTRO}>registrarse gratis 30 días</a>.</p>
    {/if}
  </div>
</div>

<style>
  .wrap { min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 2rem; background: linear-gradient(135deg, #E8F4F4, #fff); }
  .card { max-width: 420px; text-align: center; background: #fff; border-radius: 1rem; padding: 2rem; border: 2px solid #1A6B6B; box-shadow: 0 12px 32px rgba(26,107,107,.15); }
  .emoji { font-size: 3rem; display: block; margin-bottom: 0.5rem; }
  h1 { margin: 0 0 0.5rem; color: #16a34a; font-size: 1.35rem; }
  p { margin: 0.35rem 0; color: #4b5563; }
  .muted { font-size: 0.88rem; color: #6b7280; }
  .err { color: #b00020; }
  button { margin-top: 1rem; padding: 0.65rem 1.2rem; border: 0; border-radius: 8px; background: #1A6B6B; color: #fff; font-weight: 700; cursor: pointer; }
  a { color: #1A6B6B; font-weight: 600; }
</style>
